import { Button, Typography } from "@mui/material";
import styled from "styled-components";
import { useThemeMode } from "@/colors";

export const GradientText = styled(Typography)`
  & {
    ${props => props.theme.palette.mode === "dark" ? `
      color: transparent !important;
        background: linear-gradient(45deg, #5CE1E6, #7ED957) !important;
        background-color: ${props.theme.palette.background.default} !important;
        background-clip: text !important;
        -webkit-background-clip: text !important;
    ` : `
      text-decoration: underline;
      text-decoration-thickness: 4px;
      color: ${props.theme.palette.text.primary};
    `}
  }
`;

export const GradientSpan = styled.span`
  color: transparent;
  background: linear-gradient(45deg, #5CE1E6, #7ED957);
  background-color: ${props => props.theme.palette.background.default};
  background-clip: text;
  -webkit-background-clip: text;
`;
